/**
 * Mapping conversion Produit SERVICE → Prestation (sans twin).
 */

/**
 * @param {object} source — formData et/ou produit legacy
 * @param {{ commercantId: string, commercantType?: string, normalizeTauxTVA?: Function }} ctx
 */
export function buildServiceToPrestationConversionPayload(source, ctx = {}) {
  const {
    commercantId,
    commercantType,
    normalizeTauxTVA,
  } = ctx;

  const produit = source?.produit || source || {};
  const formData = source?.formData || source || {};

  const nom = String(formData.nom || produit.nom || '').trim();
  const prixRaw = formData.prix ?? produit.prix;
  const prix = parseFloat(String(prixRaw ?? '').replace(',', '.'));

  const images = Array.isArray(formData.images)
    ? formData.images.filter((img) => typeof img === 'string' && img.length > 0)
    : Array.isArray(produit.images)
      ? produit.images
      : [];

  const prixPromoRaw = formData.prixPromo ?? produit.prixPromo;
  const prixPromo = prixPromoRaw
    ? parseFloat(String(prixPromoRaw).replace(',', '.'))
    : null;

  const categorie = String(formData.categorie || produit.categorie || '').trim() || null;
  const sousCategorie =
    String(formData.sousCategorie || produit.sousCategorie || '').trim() || null;

  const tauxTVA =
    typeof normalizeTauxTVA === 'function'
      ? normalizeTauxTVA(formData.tauxTVA ?? produit.tauxTVA, commercantType)
      : formData.tauxTVA ?? produit.tauxTVA;

  return {
    commercantId,
    produitSourceId: produit.id,
    nom,
    description: formData.description || produit.description || null,
    images,
    dureeMinutes: Number(formData.dureeMinutes || produit.dureeMinutes) || 60,
    prix: Number.isFinite(prix) ? prix : null,
    prixPromo: Number.isFinite(prixPromo) ? prixPromo : null,
    maxParticipants: Number(formData.maxParticipants || produit.maxParticipants) || 1,
    couleur: formData.couleur || produit.couleur || undefined,
    equipementFourni: Boolean(
      formData.equipementFourni ?? produit.equipementFourni ?? false
    ),
    preparationRequis:
      formData.preparationRequis || produit.preparationRequis || null,
    ordre:
      formData.ordre != null
        ? Number(formData.ordre)
        : produit.ordre != null
          ? Number(produit.ordre)
          : undefined,
    tauxTVA,
    categorie,
    sousCategorie,
    reservationEnLigne: true,
    actif: true,
  };
}
